module.exports = __webpack_public_path__ + "media/icons/minus-7261c44a.svg";